import type { TranslationFunctions } from "@/i18n/i18n-types"
import type { LocalizedString } from "typesafe-i18n"
import type { RequestInitExtended } from "@/api/request-middleware"

const ONE_HOUR = 1000 * 60 * 60

export class RequestOptions {
  private readonly init: RequestInitExtended = {}

  private constructor() {}

  static create(): RequestOptions {
    return new RequestOptions()
  }

  static cached(duration: number = ONE_HOUR): RequestOptions {
    return new RequestOptions().cached(duration)
  }

  static noCache(): RequestOptions {
    return new RequestOptions().noCache()
  }

  static noSpinner(): RequestOptions {
    return new RequestOptions().noSpinner()
  }

  static cachedWithLabel(label: (ll: TranslationFunctions) => LocalizedString, overrides?: RequestInitExtended): RequestInitExtended {
    return RequestOptions.cached().withSpinnerLabel(label).merge(overrides)
  }

  static clearAllCache(): RequestOptions {
    return new RequestOptions().clearAllCache()
  }

  cached(duration: number = ONE_HOUR): RequestOptions {
    this.init.middleware ??= {}
    this.init.middleware.cache ??= {}
    this.init.middleware.cache.duration = duration
    return this
  }

  noCache(): RequestOptions {
    this.init.middleware ??= {}
    this.init.middleware.cache ??= {}
    this.init.middleware.cache.none = true
    return this
  }

  clearAllCache(): RequestOptions {
    this.init.middleware ??= {}
    this.init.middleware.cache ??= {}
    this.init.middleware.cache.clearAll = true
    return this
  }

  noSpinner(): RequestOptions {
    this.init.middleware ??= {}
    this.init.middleware.spinner ??= {}
    this.init.middleware.spinner.skip = true
    return this
  }

  withSpinnerLabel(label: (ll: TranslationFunctions) => LocalizedString): RequestOptions {
    this.init.middleware ??= {}
    this.init.middleware.spinner ??= {}
    this.init.middleware.spinner.loadingText = label
    return this
  }

  doNotSetContentType(): RequestOptions {
    this.init.middleware ??= {}
    this.init.middleware.headers ??= {}
    this.init.middleware.headers.doNotSetContentType = true
    return this
  }

  build(): RequestInitExtended {
    return this.init
  }

  merge(overrides?: RequestInitExtended): RequestInitExtended {
    if (!overrides) return this.init
    return RequestOptions.mergeInit(this.init, overrides)
  }

  static mergeInit(defaults: RequestInitExtended, overrides: RequestInitExtended): RequestInitExtended {
    return {
      ...defaults,
      ...overrides,
      middleware: {
        ...defaults.middleware,
        ...overrides.middleware,
        cache: { ...defaults.middleware?.cache, ...overrides.middleware?.cache },
        spinner: { ...defaults.middleware?.spinner, ...overrides.middleware?.spinner },
        headers: { ...defaults.middleware?.headers, ...overrides.middleware?.headers },
      }
    }
  }
}
